import React from 'react';
import { Checkbox, Button } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import DomiciliationGuard from '../../../components/DomiciliationGuard';

const PolicyReceiptsList = ({
  // Data props
  currentReceipts,
  currency,
  
  // State props
  expandedDetails,
  selectedReceipts,
  errorMessages,
  isInitialLoading,
  
  // Function props
  toggleDetails,
  handleReceiptSelection,
  handleToggleSelectAll,
  handleToggleDeselectAll,
  getCurrentToken,
  clientToken,
  recurringPaymentRequestAgent,
  
  // Component props
  PolicyDetails,
  DomiciliationContainer,
  ChangePaymentMethodAction,
  Spinner,
  
  // Styles props
  classes,
  
  // Navigation props
  history
}) => {
  const formatDate = (date) => {
    if (!date) return '';
    return moment(date).format('DD/MM/YYYY');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        paddingRight: isMobile ? '0' : '3rem'
      }}
    >
      {(() => {
        if (isInitialLoading) {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '40px',
                minHeight: '200px'
              }}
            >
              <Spinner />
              <p style={{ fontSize: '16px', fontFamily: 'Sura Sans', marginTop: '20px', color: '#888B8D' }}>
                Cargando recibos...
              </p>
            </div>
          );
        }

        return currentReceipts && currentReceipts.data && currentReceipts.data.length > 0 ? (
          currentReceipts.data.map(policy => {
            const policyMetadata = currentReceipts.metadata
              ? currentReceipts.metadata.find(
                  meta =>
                    meta.policy ===
                    `${policy.policy_details.office_id} - ${policy.policy_details.product_id} - ${policy.policy_id}`
                )
              : null;

            const orderedInvoices = policyMetadata
              ? policyMetadata.invoices.sort((a, b) => a.partiality_number - b.partiality_number)
              : [];

            // Ordenar los recibos según el partiality_number de orderedInvoices
            const orderedReceipts = [...policy.receipts].sort((a, b) => {
              const invoiceA = orderedInvoices.find(inv => inv.identifier === a.invoice);
              const invoiceB = orderedInvoices.find(inv => inv.identifier === b.invoice);
              const partialityA = invoiceA ? invoiceA.partiality_number : 0;
              const partialityB = invoiceB ? invoiceB.partiality_number : 0;
              return partialityA - partialityB;
            });

            return (
              <div key={policy.policy_id} style={{ marginTop: isMobile ? '8px' : '20px' }}>
                {policy.policy_master_id && (
                  <span
                    style={{
                      color: '#2D6DF6',
                      fontSize: '16px',
                      fontWeight: '400',
                      fontFamily: 'Sura Sans',
                      marginLeft: '5px',
                      marginBottom: '4px',
                      display: 'block'
                    }}
                  >
                    Póliza maestra: {policy.policy_master_id}
                  </span>
                )}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: isMobile ? 'column' : 'row'
                  }}
                >
                  <span
                    style={{
                      color: '#2D6DF6',
                      fontSize: '26px',
                      fontWeight: '600',
                      fontFamily: 'Sura Sans',
                      marginLeft: '5px'
                    }}
                  >
                    Póliza: {policy.policy_id} - {policy.type_policy}
                  </span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: isMobile ? 'flex-start' : 'center',
                      gap: '10px',
                      width: isMobile ? '100%' : 'auto',
                      marginTop: isMobile ? '10px' : '0'
                    }}
                  >
                    {(policy.recurring_payment === 1 || policy.gestor === 'ALEA') && (
                      <DomiciliationGuard token={clientToken}>
                        <ChangePaymentMethodAction row={policy} paymentToken={getCurrentToken()} />
                      </DomiciliationGuard>
                    )}
                    <span
                      onClick={() => toggleDetails(policy.policy_id)}
                      style={{
                        color: '#2D6DF6',
                        fontSize: '12px',
                        fontWeight: '400',
                        fontFamily: 'Sura Sans',
                        cursor: 'pointer'
                      }}
                    >
                      {expandedDetails[policy.policy_id] ? 'OCULTAR DETALLE' : 'VER DETALLE'}
                    </span>
                  </div>
                </div>

                {/* Detalles de póliza expandibles */}
                {expandedDetails[policy.policy_id] && <PolicyDetails policy={policy} />}

                {/* Domiciliación con permisos */}
                {policy.recurring_payment === 0 && policy.gestor !== 'ALEA' && (
                  <DomiciliationGuard token={clientToken}>
                    <DomiciliationContainer
                      policy={policy}
                      clientToken={getCurrentToken()}
                      currency={currency}
                      recurringPaymentRequestAgent={recurringPaymentRequestAgent}
                    />
                  </DomiciliationGuard>
                )}

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    marginTop: '20px',
                    width: '100%'
                  }}
                >
                  <span
                    style={{
                      color: '#888B8D',
                      fontSize: '16px',
                      fontWeight: '400',
                      fontFamily: 'Sura Sans',
                      marginLeft: '5px'
                    }}
                  >
                    Selecciona los recibos relacionados a tu póliza que quieras pagar
                  </span>

                  {/* Tabla de recibos */}
                  <div
                    className={classes.receiptsTable}
                    style={{
                      overflowX: isMobile ? 'scroll' : 'visible',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px'
                    }}
                  >
                    {/* Header de la tabla */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: '5px',
                        width: isMobile ? '800px' : '100%'
                      }}
                    >
                      <Checkbox
                        checked={orderedInvoices.every(invoice =>
                          selectedReceipts.some(item => item.invoice === invoice.identifier)
                        )}
                        indeterminate={
                          orderedInvoices.some(invoice =>
                            selectedReceipts.some(item => item.invoice === invoice.identifier)
                          ) &&
                          !orderedInvoices.every(invoice =>
                            selectedReceipts.some(item => item.invoice === invoice.identifier)
                          )
                        }
                        onChange={e => {
                          if (e.target.checked) {
                            handleToggleSelectAll(
                              orderedInvoices,
                              policy.policy_id,
                              policy.receipts,
                              policy.policy_details,
                              policy.type_policy,
                              policy.policy_master_id
                            );
                          } else {
                            handleToggleDeselectAll(orderedInvoices);
                          }
                        }}
                        style={{
                          color: '#2D6DF6'
                        }}
                        classes={{
                          checked: 'Mui-checked'
                        }}
                      />
                      <div
                        style={{
                          flex: 1,
                          color: '#888B8D',
                          fontSize: '12px',
                          fontWeight: '400',
                          fontFamily: 'Sura Sans'
                        }}
                      >
                        No. Recibo
                      </div>
                      <div
                        style={{
                          flex: 2,
                          color: '#888B8D',
                          fontSize: '12px',
                          fontWeight: '400',
                          fontFamily: 'Sura Sans'
                        }}
                      >
                        Vigencia
                      </div>
                      <div
                        style={{
                          flex: 1,
                          color: '#888B8D',
                          fontSize: '12px',
                          fontWeight: '400',
                          fontFamily: 'Sura Sans'
                        }}
                      >
                        Fecha Límite de Pago
                      </div>
                      <div
                        style={{
                          flex: 1,
                          textAlign: 'center',
                          color: '#888B8D',
                          fontSize: '12px',
                          fontWeight: '400',
                          fontFamily: 'Sura Sans'
                        }}
                      >
                        Importe
                      </div>
                    </div>

                    {/* Filas de recibos */}
                    {orderedReceipts.map(receipt => (
                      <div
                        key={receipt.uuid}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          minHeight: '65px',
                          width: isMobile ? '800px' : '100%'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            border: `1px solid ${
                              errorMessages[receipt.uuid]
                                ? '#D12D35'
                                : selectedReceipts.some(item => item.uuid === receipt.uuid)
                                ? '#E6FAEF'
                                : '#ccc'
                            }`,
                            borderRadius: '20px',
                            height: '62px',
                            width: 'calc(100% - 10px)',
                            marginLeft: '5px',
                            background: selectedReceipts.some(item => item.uuid === receipt.uuid)
                              ? '#E6FAEF'
                              : '#FFFFFF',
                            boxShadow: selectedReceipts.some(item => item.uuid === receipt.uuid)
                              ? '0px 0px 6px #00000029'
                              : 'none'
                          }}
                        >
                          <div>
                            <Checkbox
                              checked={selectedReceipts.some(item => item.uuid === receipt.uuid)}
                              onChange={() =>
                                handleReceiptSelection(
                                  receipt.uuid,
                                  receipt.invoice,
                                  orderedInvoices,
                                  receipt,
                                  policy.policy_details.currency,
                                  policy.policy_id,
                                  policy.type_policy,
                                  policy.policy_master_id
                                )
                              }
                              style={{
                                color: '#2D6DF6'
                              }}
                              classes={{
                                checked: 'Mui-checked'
                              }}
                            />
                          </div>
                          <div
                            style={{
                              flex: 1,
                              textAlign: 'left',
                              color: errorMessages[receipt.uuid] ? '#D12D35' : '#000000',
                              fontSize: '16px',
                              fontWeight: '400',
                              fontFamily: 'Sura Sans'
                            }}
                          >
                            {receipt.invoice}
                          </div>
                          <div
                            style={{
                              flex: 2,
                              textAlign: 'left',
                              color: '#000000',
                              fontSize: '16px',
                              fontWeight: '400',
                              fontFamily: 'Sura Sans'
                            }}
                          >
                            {formatDate(receipt.issue_date)} - {formatDate(receipt.due_date)}
                          </div>
                          <div
                            style={{
                              flex: 1,
                              textAlign: 'left',
                              color: '#000000',
                              fontSize: '16px',
                              fontWeight: '400',
                              fontFamily: 'Sura Sans'
                            }}
                          >
                            {formatDate(receipt.extension_date)}
                          </div>
                          <div
                            style={{
                              flex: 1,
                              textAlign: 'center',
                              color: '#000000',
                              fontSize: '16px',
                              fontWeight: '600',
                              fontFamily: 'Sura Sans'
                            }}
                          >
                            {new Intl.NumberFormat('en-US', {
                              style: 'currency',
                              currency: 'USD',
                              minimumFractionDigits: 2
                            }).format(receipt.total)}
                          </div>
                        </div>
                        {errorMessages[receipt.uuid] && (
                          <span style={{ color: '#D12D35', fontSize: '12px', marginLeft: '20px' }}>
                            {errorMessages[receipt.uuid]}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '20px'
            }}
          >
            <p style={{ fontSize: '16px', fontFamily: 'Sura Sans' }}>No hay información de recibos disponibles</p>
            <Button
              onClick={() => history.push('/cobranza/cliente')}
              className={classes.buttonPrimary}
              style={{
                minWidth: '256px',
                marginTop: '20px'
              }}
            >
              Volver al inicio
            </Button>
          </div>
        );
      })()}
    </div>
  );
};

export default PolicyReceiptsList;



// WEBPACK FOOTER //
// ./src/containers/client/receipts/PolicyReceiptsList.js